import { render, staticRenderFns } from "./UserReferralIncomes.vue?vue&type=template&id=5e2b024b&scoped=true&"
import script from "./UserReferralIncomes.vue?vue&type=script&lang=js&"
export * from "./UserReferralIncomes.vue?vue&type=script&lang=js&"
import style0 from "./UserReferralIncomes.vue?vue&type=style&index=0&id=5e2b024b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2b024b",
  null
  
)

export default component.exports